export default "__VITE_ASSET__Byscnj$2__"